import WithRender from "../../templates/imageEditor/imageContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getEditor",
      "getCanvas",
      "getFullFormatDim",
      "getFullMargins",
      "getFormat",
      "getThickness",
      "getMargin",
      "getReady",
      "getImage"
    ]),
    canvasImageDimByFormatWatch: function () {
      return this.getEditor.dim.canvasImageDimByFormat;
    },
    focalPoint: function () {
      return this.getEditor.focalPoint;
    },
    zoom: function () {
      return this.getEditor.zoom;
    },
    canvas: function () {
      return this.getCanvas;
    },
    fullFormat: function () {
      return this.getFullFormatDim;
    },
    fullMargins: function () {
      return this.getFullMargins;
    },
    format: function () {
      return this.getFormat;
    },
    originalImage: function () {
      return this.getImage.original;
    },
    margins: function () {
      return this.getMargin;
    },
    thickness: function () {
      return this.getThickness.thickness;
    },
    getStyle: function () {
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var tmp = this.getEditor.dim.canvasImageDimByFormat;
        var size = {
          bottom: tmp.bottom,
          height: tmp.height,
          left: tmp.left,
          right: tmp.right,
          top: tmp.top,
          width: tmp.width
        };

        if (this.margins.type <= 0) {
          size.top = 0;
          size.right = 0;
          size.bottom = 0;
          size.left = 0;
        }

        var zoom = this.zoom / 100;

        var left =
          Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) * -1;
        var top =
          Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) * -1;

        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);

        return {
          "background-image": "url('" + this.getImage.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": left + "px " + top + "px"
        };
      }
    }
  },
  methods: {},
  watch: {
    canvasImageDimByFormatWatch: {
      handler: function (canvasImageDimByFormat, oldVal) {
        var imageDimByFormat = this.getEditor.dim.imageDimByFormat;
        var margins = this.margins;
        var thickness = this.thickness;
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var unit = imageDimByFormat.unit / editorCanvasByFormat.unit;

        var top1 = Math.round((margins.top + thickness) * unit);
        var right1 = Math.round((margins.right + thickness) * unit);
        var bottom1 = Math.round((margins.bottom + thickness) * unit);
        var left1 = Math.round((margins.left + thickness) * unit);

        if (margins.type > 0) {
          var top = top1;
          var right = right1;
          var bottom = bottom1;
          var left = left1;
        } else {
          var top = 0;
          var right = 0;
          var bottom = 0;
          var left = 0;
        }

        var zoom = this.getEditor.zoom / 100;
        var ui = {
          bgPosition: {
            left: 0,
            top: 0
          },
          elementSize: {
            width: canvasImageDimByFormat.width * zoom,
            height: canvasImageDimByFormat.height * zoom
          }
        };
        this.$store.dispatch("storeFocalPoint", { ui, zoom });
      },
      deep: true
    }
  }
});
